import React, { useState, useEffect } from "react";
import {FormControl, InputLabel, Select, MenuItem,Button, Box } from "@mui/material";
import SubmitButton from "../customComponent/SubmitButton";
import { Link } from "react-router-dom";

const FilterComponent = ({
  centerCode,
  setCenterCode,
  shiftTime,
  setShiftTime,
  examName,
  setExamName,
  handleFilterSubmit,
  rows,
  cities,
  selectedCity,
  setSelectedCity,
}) => {

  const allCenters = JSON.parse(localStorage.getItem("allCenters")) || [];
  const uniqueShiftTimes = [...new Set(rows.map((row) => row.shiftTime))];

  console.log("exame name :",examName);
  
  // Static exam name, you can directly assign it here
  // const staticExamName = "KPSC_18_FEB";

  // Ensure the selected examName is set to the static value
  // useEffect(() => {
  //   if (examName !== staticExamName) {
  //     setExamName(staticExamName);  // Set the exam name to the static value
  //   }
  // }, [examName, setExamName]);

  return (
    <Box
      component="form"
      onSubmit={handleFilterSubmit}
      sx={{
        display: "flex",
        gap: 2,
        mt: 4,
        mb: 2,
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      {/* Static Exam Name */}
      {/* <Box sx={{ minWidth: 200 }}>
        <select
          label="Select Exam"
          value={examName || ""} // Directly set to static exam name
          // disabled 
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            backgroundColor: "#f0f0f0", // Optional styling for read-only
          }}
        >
          <option value="" disabled selected>Selcet Exam</option>
          <option value={examName}>{examName}</option>
        </select>
      </Box> */}
      {/* City Filter */}
      
      
      
      <Box sx={{ minWidth: 200 }}>
        <select
          value={centerCode || ""} // Ensure the value is controlled and matches the selected center code
          onChange={(e) => setCenterCode(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        >
          <option value="" disabled selected>
            Select Center
          </option>
          <option value="all">All</option>
          {rows.map((row) => (
            <option key={row.centerCode} value={row.centerCode}>
              ({row.centerCode})&nbsp;-&nbsp;{row.centerName.substr(0, 20) + "..."}
            </option>
          ))}
        </select>
      </Box>
      

      {/* <Box sx={{ minWidth: 200 }}>
        <select
          value={shiftTime || ""} // Ensure the value is controlled and matches the selected shift time
          onChange={(e) => setShiftTime(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        >
          <option value="" disabled selected>
            Select Shift
          </option>
          {uniqueShiftTimes.map((shift) => (
            <option key={shift} value={shift}>
              {shift}
            </option>
          ))}
        </select>
      </Box> */}

      <SubmitButton type="submit" color="primary" />
      <Box sx={{ minWidth: 200 }}>
            {/* City Filter */}
      {/* <FormControl fullWidth>
        <InputLabel>Select City</InputLabel>
        <Select
          value={selectedCity}
          label="Select City"
          onChange={(e) => setSelectedCity(e.target.value)}
        >
          {cities.map((city) => (
            <MenuItem key={city} value={city}>
              {city}
            </MenuItem>
          ))}
        </Select>
      </FormControl> */}
        </Box>
    </Box>
  );
};

export default FilterComponent;
